export default __webpack_public_path__ + "static/media/Planhyvlat 15.498b23a8.jpg";